import './index.scss';
import React from 'react';
import { getDefaultCover } from '@/utils';
import { Icon } from 'antd-mobile';
import moment from 'moment';
import Empty from '@/components/empty';

const { live: liveCover } = getDefaultCover();

/** 课堂纪律组件 */
function ClassroomDiscipline(props) {
  const { list, handleClick, handleRemove = () => {}, showRemove } = props;

  const onRemove = (e, item, index) => {
    e.stopPropagation();
    handleRemove(item, index);
  };
  return (
    <div className="classroom-discipline">
      <div className="classroom-discipline-content">
        <ul className="classroom-discipline-list">
          {list.map((item, index) => {
            return (
              <li
                onClick={() => handleClick(item)}
                className="classroom-discipline-list-item"
                key={'cladis_list_' + index}
              >
                {showRemove && (
                  <Icon
                    onClick={(e) => onRemove(e, item, index)}
                    type="cross-circle"
                    className="discipline-icon"
                  />
                )}
                <img src={liveCover} alt="行为" />
                <p className="item-title">{item.describes}</p>
                <p className="item-time">{moment(item.times * 1).format('HH:mm:ss')}</p>
              </li>
            );
          })}
          {list.length === 0 && (
            <div className="empty-field">
              <Empty />
            </div>
          )}
        </ul>
      </div>
    </div>
  );
}

export default ClassroomDiscipline;
